import { airMilesInfo } from "@/utils/content";
import { routes } from "@/utils/routes";
import { useRouter } from "next/router";
import React from "react";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import classes from "@/styles/invitation/airmileinfo.module.css";
import { useIsMobile } from "@/hooks/useIsMobile";

const airMilesOffers = [
  {
    title: "GET",
    amount: "10",
    offerType: "Reward Miles™",
    description:
      "When you register for ShipVista and add your AIR MILES collector card number",
  },
  {
    title: "GET",
    amount: "1",
    offerType: "Reward Mile™",
    description: "For every $25 spent each month on shipping services",
  },
  {
    title: "GET",
    amount: "50",
    offerType: "Bonus Miles™",
    description: "When you spend $1,500 a month",
  },
];

const getTermId = (termNumber: number) => {
  return "terms-" + termNumber;
};

interface AirMilesInfoProps {
  hideTitle?: boolean;
}

const AirMilesInfo = ({ hideTitle }: AirMilesInfoProps) => {
  const history = useRouter();
  const isMobile = useIsMobile();

  const handleTermLinkClick = (e: any, termNumber: number) => {
    e.preventDefault();
    const terms = `${routes.airmiles}#${getTermId(termNumber)}`;
    if (terms) {
      history.push(terms);
    }
  };

  const handleDetailsClick = () => {
    history.push(routes.airmiles);
  };

  return (
    <Container className="container">
      {!hideTitle && <h4>{airMilesInfo.en.title}</h4>}
      <Row className={`${isMobile ? "" : "w-75 mx-auto"}`}>
        {airMilesOffers.map((a, i) => (
          <Col className="mb-3" xs={12} sm={6} md={4} key={i}>
            <Card className={classes.card}>
              <div className={classes.cardHeader}>
                <h2 className="fw-bold">{a.title}</h2>
                <h1>{a.amount}</h1>
                <h2 className="mt-5 pt-5">{a.offerType}</h2>
              </div>
              <CardBody>
                <div className="top">
                  <a
                    href={getTermId(i + 1)}
                    onClick={(e) => handleTermLinkClick(e, i + 1)}
                    className="term-link"
                  >
                    {i + 1}
                  </a>
                  <span className="get">{a.title}</span>
                  <span className="amount">{a.amount}</span>
                  <span className="offerType">
                    {a.offerType}
                    <sup>TM</sup>
                  </span>
                </div>
                <div className="bottom">
                  <p>{a.description}</p>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
      <div className="text-center mt-5">
        <Button outline onClick={handleDetailsClick}>
          {airMilesInfo.en.ctaText}
        </Button>
      </div>
    </Container>
  );
};

export default AirMilesInfo;
